var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "summary" }, [
    _c("div", { staticClass: "boxes" }, [
      _c("div", { staticClass: "box" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.model.messages.length)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("wp.messages"))),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "box" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "value" }, [
            _vm._v(
              _vm._s(
                _vm.model.all
                  ? _vm.contacts.length
                  : _vm.model.customNumbers.length
              )
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("wp.recipients"))),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "box" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.getSendingTime())),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("wp.broadcast.sendingTime"))),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "box" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.getEstimatedTookTime())),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("wp.estimatedTime"))),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("span", { staticClass: "material-icons" }, [
        _vm._v(" outgoing_mail "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v(" people ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v(" schedule ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v(" watch_later ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }